import React from 'react';
import AgentStreamingResult from './AgentStreamingResult';
import QueryStreamingResult from './QueryStreamingResult';
import { ResultContextProvider } from '@/contexts/ResultContext';
import ReasoningStreamingResult from './ReasoningStreamingResult';
import { ReasoningResultContextProvider } from '@/contexts/ReasoningResultContext';
import { ReasoningChatProvider } from './reasoningChat/ReasoningChatContext';

const StreamingResult = ({ resultId, isAgentScriptResult = false, isReasoningQueryResult = false }) => {
  if (isReasoningQueryResult) {
    return (
      <ReasoningResultContextProvider resultId={resultId}>
        <ReasoningChatProvider>
          <ReasoningStreamingResult />
        </ReasoningChatProvider>
      </ReasoningResultContextProvider>
    );
  }
  if (isAgentScriptResult) {
    return (
      <ResultContextProvider resultId={resultId} isAgentScriptResult={isAgentScriptResult}>
        <AgentStreamingResult />
      </ResultContextProvider>
    );
  }
  return (
    <ResultContextProvider resultId={resultId}>
      <QueryStreamingResult />
    </ResultContextProvider>
  );
};

export default StreamingResult;
